export function Convos() {
  return (
    <div>
      <p className="text-gray-600 dark:text-gray-400">Coming soon...</p>
    </div>
  );
}
